import isArray from "lodash/isArray";
import isPlainObject from "lodash/isPlainObject";
import isBoolean from "lodash/isBoolean";

import patternAcousticPerformances from "../constants/patternAcousticPerformances";

export default (patternId, patternConfig) => {
  const { index } = patternConfig;
  const config = patternAcousticPerformances[patternId];

  if (isArray(config)) {
    return config;
  } else if (isPlainObject(config)) {
    const configFirstValue = patternConfig[Object.keys(patternConfig)[0]];

    if (isBoolean(configFirstValue)) {
      const sum = Object.keys(patternConfig).reduce((acc, k) => {
        acc += patternConfig[k] ? 1 : 0;
        return acc;
      }, 0);
      console.log(patternConfig);
      return config[sum];
    }

    return config[index];
  } else {
    console.log(`Invalid pattern config for #${patternId}`);
  }
};



// WEBPACK FOOTER //
// ./src/utils/getPatternAcousticPerf.js